import { IEvent } from "../../../models/Event"
import React, { useEffect, useState } from "react"

export const EnrollmentTable: React.FC<{ event: IEvent }> = ({ event }) => {
    const [totalPrice, setTotalPrice] = useState<number>(0)
    const [hasPricesFirst, setHasPricesFirst] = useState<boolean>(false)
    const [hasPricesSeconed, setHasPricesSeconed] = useState<boolean>(false)
    const [hasPricesThird, setHasPricesThird] = useState<boolean>(false)

    useEffect(() => {
        checkPrices()
    }, [])

    const checkPrices = () => {
        let totalPrices: number = 0;
        event.heats.map((heat) => { heat.prices && heat.prices.map((price: number) => totalPrices = totalPrices + price) })
        setTotalPrice(totalPrices)
        totalPrices = 0
        event.heats.map(heat => { heat.prices && (totalPrices = totalPrices + heat.prices[0]) })
        setHasPricesFirst(totalPrices > 0)
        totalPrices = 0
        event.heats.map(heat => { heat.prices && (totalPrices = totalPrices + heat.prices[1]) })
        setHasPricesSeconed(totalPrices > 0)
        totalPrices = 0
        event.heats.map(heat => { heat.prices && (totalPrices = totalPrices + heat.prices[2]) })
        setHasPricesThird(totalPrices > 0)
    }

    return (
        <div className="container container--narrow section--tight enrollment-table">
            {totalPrice != 0 && <div className="card">
                <h2 className="card-title">טבלת מחירים</h2>
                <div className="table-wrap">
                    <table className="data-table top-table">
                        <thead>
                        <tr>
                            <th>מקצה</th>
                            {hasPricesFirst && <th>
                                <div>
                                    הרשמה מוקדמת עד תאריך
                                </div>
                                <div className="th-date">
                                    {event.priceDates[0]}
                                </div>
                            </th>}
                            {hasPricesSeconed && <th>
                                <div>
                                    הרשמה רגילה עד תאריך
                                </div>
                                <div className="th-date">
                                    {event.priceDates[1]}
                                </div>
                            </th>}
                            {hasPricesThird && <th>
                                <div>
                                    הרשמה מאוחרת עד תאריך
                                </div>
                                <div className="th-date">
                                    {event.priceDates[2]}
                                </div>
                            </th>}
                        </tr>
                        </thead>
                        {event.heats.map((heat, index) =>
                            <tbody key={index}>
                            {heat.prices && <tr >
                                <td>{heat.description}</td>
                                {hasPricesFirst && <td>{heat.prices[0]}₪</td>}
                                {hasPricesSeconed && <td>{heat.prices[1]}₪</td>}
                                {hasPricesThird && <td>{heat.prices[2]}₪</td>}
                            </tr>}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>}

            <div className="card">
                <h2 className="card-title">זמני זינוק</h2>
                <div className="table-wrap">
                    <table className="data-table bottom-table">
                        <thead>
                        <tr>
                            <th>מקצה</th>
                            <th>סוג</th>
                            <th>זמן זינוק</th>
                            <th>מגיל</th>
                        </tr>
                        </thead>
                        <tbody>
                        {event.heats.map((heat, index) =>
                            <tr key={index}>
                                <td>{heat.description}</td>
                                <td>{heat.amami ? `עממי` : `תחרותי`}</td>
                                <td>{heat.startHeat}</td>
                                <td>{heat.minAge}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="enrollment-actions">
                {(event.status === 'registration') ?
                    <a className="btn btn-primary btn-lg" href={event.registrationUrl}>לחץ להרשמה</a>
                    :
                    <h2 className="status-note">ההרשמה הסתיימה</h2>}
                {event.showParticipants != 0 &&
                    <a className="btn btn-outline btn-lg" href={event.participantsListUrl}>לחץ לרשימת המשתתפים</a>}
            </div>

            {!event.isRegistrationInEventDay &&
                <p className="callout">
                    <span className="material-icons">info</span>
                    לא תתאפשר הרשמה במקום ביום האירוע
                </p>
            }
            {event.enrollmentInclude && <div className="card enrollmentInclude">
                {event.enrollmentInclude}
            </div>}
        </div>
    )
}


